import { Component } from "react";

export default class PageHeaderRight extends Component<{ children?: React.ReactNode }> {
  public static readonly displayName = "PageHeaderRight";

  public render() {
    return this.props.children || null;
  }
}
